<template>
  <div class="yesnoalt-question">
    <button @click="toggleAnswer('no')">
      {{ question.question.no || 'No' }}
    </button>
    <div>
      <span v-if="answer === 'no'">&cross;</span>
      <span v-if="answer === 'alt'">&minus;</span>
    </div>
    <button @click="toggleAnswer('alt')">{{ question.question.alt }}</button>
    <div>
      <span v-if="answer === 'yes'">&check;</span>
      <span v-if="answer === 'alt'">&minus;</span>
    </div>
    <button @click="toggleAnswer('yes')">
      {{ question.question.yes || 'Yes' }}
    </button>
  </div>
</template>

<script>
import QuestionMixin from './QuestionMixin';

export default {
  name: 'yes-no-alt',
  mixins: [QuestionMixin],

  methods: {
    toggleAnswer(ansVal) {
      if (
        this.answer !== undefined &&
        this.answer !== null &&
        this.answer !== '' &&
        this.answer === ansVal
      ) {
        this.setAnswer(null);
      } else {
        this.setAnswer(ansVal);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.yesnoalt-question {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-columns: 1fr 60px 1fr 60px 1fr;
  grid-column-gap: 5px;
  max-width: 575px;
  width: 60%;
  height: 60px;
  margin: 0 auto;

  button,
  div {
    height: 100%;
    background-color: #eaf3f4;
    font-size: 16px;
    font-weight: bold;
  }

  button {
    border: none;
  }

  > div {
    position: relative;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  button:first-of-type {
    border-top-left-radius: 10000px;
    border-bottom-left-radius: 10000px;
  }

  button:last-of-type {
    border-top-right-radius: 10000px;
    border-bottom-right-radius: 10000px;
  }

  &[value='no'] {
    button:first-of-type,
    div:first-of-type {
      background-color: #3486a3;
      color: white;
    }
  }

  &[value='alt'] {
    button:nth-of-type(2),
    div {
      background-color: #faad41;
      color: white;
    }
  }

  &[value='yes'] {
    button:last-of-type,
    div:last-of-type {
      background-color: #978eb7;
      color: white;
    }
  }
}
</style>
